import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=1177cf2a&"
import script from "./SelectType.vue?vue&type=script&lang=js&"
export * from "./SelectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports